import { getDefaultClient } from '../../../client/defaultClient';
import type { WalletAccount } from '../../wallets/walletAccount';
import { getWaasWalletProviderFromWalletAccount } from '../getWaasWalletProviderFromWalletAccount';

type SetWaasWalletAccountPasswordParams = {
  password: string;
  walletAccount: WalletAccount;
};

/**
 * Sets a password for a WaaS wallet account.
 *
 * @param params.walletAccount - The WaaS wallet account to set the password for.
 * @param params.password - The password to set for the wallet.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves when the password is successfully set.
 */
export const setWaasWalletAccountPassword = async (
  { password, walletAccount }: SetWaasWalletAccountPasswordParams,
  client = getDefaultClient()
) => {
  const provider = getWaasWalletProviderFromWalletAccount(
    { walletAccount },
    client
  );

  return provider.setWaasWalletAccountPassword({
    password,
    walletAccount,
  });
};
